import React, {useState, useEffect} from "react";
import { useControles } from "../../context/controles.context";
import { HeaderDiv, HeaderLogoMobile, HeaderContent, ProfileIcon, HeaderButtons } from "./styles";

import { Icon } from '@iconify/react';

import { useNavigate } from 'react-router-dom';
import SideBar from "../SideBar";
import { useWhitelabel } from "../../context/whitelabel.context";

const Header = () => {
    const {isMobile, setActivePage, sideBarStatus, setSideBarStatus} = useControles()
    const {logoHorizontal, logoVertical} = useWhitelabel()
    
    

    const navigate = useNavigate()

    const handleVoltar = () => {
        setSideBarStatus(true)
        navigate('/')
    }

    return (
        <>
            {isMobile ? 
                <>
                <HeaderDiv>
                    <HeaderContent>
                        <HeaderLogoMobile>
                           {sideBarStatus ? <img src={logoVertical} style={{maxWidth: "40%"}}></img> : <>
                           <div style={{display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', color: 'var(--Primary-text)', fontSize: '20px'}} onClick={handleVoltar}>
                                <Icon icon="ph:arrow-left-bold" />
                                    <span>Voltar</span>
                                </div>
                            </>} 
                        </HeaderLogoMobile>
                        <HeaderButtons>
                            <ProfileIcon style={{width:40, height: 40, margin: 0, cursor: 'pointer'}} onClick={()=>{navigate("/perfil")
                        setActivePage(4)
                        }}>
                                <Icon icon="iconamoon:profile-fill" />
                            </ProfileIcon>
                        </HeaderButtons>
                    </HeaderContent>
                </HeaderDiv>
                </> : 
                <>
                <HeaderDiv>
                    <HeaderContent>
                        <div style={{marginLeft: "3rem"}}>
                            {sideBarStatus ? <img src={logoHorizontal} style={{width: '150px', maxWidth: '150px', maxHeight: '60px', objectFit: 'contain'}}></img> : 
                            <>
                                <div style={{display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', color: 'var(--Primary-text)', fontSize: '20px'}} onClick={handleVoltar}>
                                <Icon icon="ph:arrow-left-bold" />
                                    <span>Voltar</span>
                                </div>
                            </>} 
                        </div>
                        <HeaderButtons>
                            <ProfileIcon style={{margin: "0 20px", cursor: 'pointer'}} onClick={()=>{navigate("/perfil")
                        setActivePage(4)
                        }} >
                                <Icon icon="iconamoon:profile-fill" />
                            </ProfileIcon>
                        </HeaderButtons>
                    </HeaderContent>
                </HeaderDiv>
                
                </>
            }
            {!isMobile && sideBarStatus && <SideBar/>}
        </>
    )
}

export default Header